<script setup>
import ModulePlayer from '@/components/modules/ModulePlayer.vue'
import {onMounted, ref, computed, onUnmounted, watch} from 'vue'
import {useBroadcastStore} from "@/stores/broadcast";
import {storeToRefs} from "pinia";
import {useBreakpoint} from "@/composables/useBreakpoints";
import { useSectionsStore } from '@/stores/section'

import { useRoute } from 'vue-router'
const route = useRoute()

const moduleMiniPlayer = ref(null)
const moduleMiniPlayerWrapper = ref(null)
const minimalized = ref(false)
const handlerChangeMiniPlayer = ref(true)
const showMiniPlayer = ref(false)

const broadcast = useBroadcastStore()
const {miniPlayer} = storeToRefs(broadcast)
const {fetchMiniPlayer} = broadcast

const videoItem = computed(() => miniPlayer.value?.items?.[0] ?? null)
const videoId = computed(() => videoItem.value?._id ?? null)

const sectionsStore = useSectionsStore()
const { pageSettingType, pageSettingId } = storeToRefs(sectionsStore)

const typeSG = computed(() => pageSettingType.value === 'SG')
const typeNEWS = computed(() => pageSettingType.value === 'NEWS')
const typeVIDEO = computed(() => pageSettingType.value === 'VIDEO')

const pageId = computed(() => pageSettingId.value)

function minimalizedPlayer(payload) {

  const className = 'module-mini-player__mini-show-minimalized'
  minimalized.value = payload
  if (minimalized.value) {
    moduleMiniPlayerWrapper.value?.classList.add(className)
  } else {
    moduleMiniPlayerWrapper.value?.classList.remove(className)
  }
}

function scrollMiniPlayer() {

  const el = moduleMiniPlayer.value?.getBoundingClientRect()
  const isMiniPlayer = false

  moduleMiniPlayerWrapper.value?.classList.toggle('module-mini-player__mini', !isMiniPlayer)
  if (!isMiniPlayer) {
    if(isMiniPlayer !== handlerChangeMiniPlayer.value) {
      setTimeout(() => {
        moduleMiniPlayerWrapper.value?.classList.add("module-mini-player__mini-show")
        minimalizedPlayer(false)
      }, 100)
    }
    handlerChangeMiniPlayer.value = isMiniPlayer
  } else {
    if(isMiniPlayer !== handlerChangeMiniPlayer.value) {
      moduleMiniPlayerWrapper.value?.classList.remove("module-mini-player__mini-show")
      if(minimalized.value) {
        minimalizedPlayer(false)
      }
    }
    handlerChangeMiniPlayer.value = isMiniPlayer
  }

    // const isMiniPlayer2 = (el?.y - ((moduleMiniPlayerWrapper.value?.offsetHeight ?? 0) + 100)) > 0
    // console.log(isMiniPlayer2)

    // if(!isMiniPlayer2) {
    //   moduleMiniPlayerWrapper.value?.classList.add("module-mini-player__mini-show-run")
    // } else {
    //   moduleMiniPlayerWrapper.value?.classList.remove("module-mini-player__mini-show-run")
    // }

    const navHolder = ref(null);
    navHolder.value = document.querySelector('.nav__content');
    const rect = navHolder.value.getBoundingClientRect();

    if (rect.top === 0) {
      moduleMiniPlayerWrapper.value?.classList.add("module-mini-player__mini-show-run")
      moduleMiniPlayerWrapper.value?.classList.add("module-mini-player__mini-show")
    } else {
      moduleMiniPlayerWrapper.value?.classList.remove("module-mini-player__mini-show-run")
      moduleMiniPlayerWrapper.value?.classList.add("module-mini-player__mini-show")
    }

}

watch(
  () => route.path,
  (newPath, oldPath) => {
    if(moduleMiniPlayer.value !== null) {
      minimalizedPlayer(false)
    }
    var resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);
  }
)

const { isFullHd } = useBreakpoint()

const mini = ref(null);

onMounted(() => {
  fetchMiniPlayer().then(() => {
    if (moduleMiniPlayer.value) {
      setTimeout(() => {
        showMiniPlayer.value = true
      }, 3000)
      scrollMiniPlayer()
      window.addEventListener('scroll', scrollMiniPlayer)
      window.addEventListener('resize', scrollMiniPlayer)
    }
  })
})

onUnmounted(() => {
  if (moduleMiniPlayer.value) {
    window.removeEventListener('scroll', scrollMiniPlayer)
    window.removeEventListener('resize', scrollMiniPlayer)
  }
})
</script>

<template>
  <section 
    class="module-mini-section"
    ref="moduleMiniPlayer" 
    v-if="videoItem && pageId !== 71192118 && (typeSG || typeNEWS || typeVIDEO)"
  >
    <div :class="['module-mini-player', { 'module-mini-player__show': showMiniPlayer }]" >
      <div class="module-mini-player__container">
      <div ref="moduleMiniPlayerWrapper" class="module-mini-player__wrapper">
        <button ref="mini" class="module-mini-player__arrow" v-if="!minimalized" @click="minimalizedPlayer(true)">
          <i class="icon-up-open-mini"></i>
        </button>
        <div class="module-mini-player__video">
          <module-player :video-id="videoId" :autoplay="true" :volumeLevel="0"/>
        </div>
        <div class="module-mini-player__desc">
          <span class="module-mini-player__name"></span>
          <span class="module-mini-player__text">{{ videoItem?.website_title || videoItem?.title  }}</span>
          <button class="module-mini-player__arrow-minimalized" v-if="minimalized" @click="minimalizedPlayer(false)">
            <i class="icon-down-open-mini"></i>
          </button>
        </div>
      </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@import "@/assets/scss/components/modules/module-mini-player.scss";
</style>
